import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export const handleDownloadExcel = async (filename, columns, rows) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(filename);

  // Add column headers
  worksheet.columns = columns.map(col => ({ header: col.Header, key: col.accessor }));

  // Add rows
  rows.forEach(row => {
    const rowData = {};
    worksheet.columns.forEach(col => {
      rowData[col.key] = row[col.key] && row[col.key].props ? '' : row[col.key]; // React component (e.g., avatar) is set to an empty string
    });
    worksheet.addRow(rowData);
  });

  // Adjust column widths
  worksheet.columns.forEach(column => {
    const lengths = column.values.map(value => value ? value.toString().length : 0);
    const maxLength = Math.max(...lengths.filter(length => !isNaN(length)));
    column.width = maxLength + 2;
  });

  // Create buffer and save
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), filename + ".xlsx");
};
